(ns app.front.view.property.v2.merge-modal
  (:require [app.domain.property.model :as property-model]
            [app.front.municipality :as municipality]
            [app.front.ui :as ui]
            [app.front.ui.modal :as ui-modal]
            [app.front.view.create-application.gis-search :as gis-search]
            [app.front.view.property.subs :as property-subs]
            [app.front.view.workspace.map :as workspace-map]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]))

(defn property-search-section [tr parent-property]
  (let [municipality    (-> parent-property :property/municipality)
        domain-group-id (-> parent-property :property/group :group/id)]
    [:div
     [:h4.text-md.font-medium.mb-2 (tr [:property-view/add-properties-to-merge])]
     [:p.text-sm.text-gray-600.mb-4 (tr [:property-view/search-and-select-properties])]
     [:div.relative
      [gis-search/address-search
       {:tr                tr
        :domain-group-id   domain-group-id
        :municipalities    [(:municipality/number municipality)]
        :show-existing?    false
        :class             "w-full"
        :light             false
        :on-select-address (fn [result]
                             (rf/dispatch [::property-subs/add-selected-merge-property result])
                             (rf/dispatch [::gis-search/clear-address-search]))
        :clear-fn          (fn []
                             (rf/dispatch [::gis-search/clear-address-search]))
        :on-error-evt      [::property-subs/merge-search-error]}]]]))

(defn selected-properties-list [tr parent-property selected-props]
  (let [all-properties (into [parent-property] selected-props)]
    [:div
     [:h5.text-sm.font-medium.mb-2 (tr [:property-view/properties-to-merge])]
     [:div.space-y-2
      (map-indexed
        (fn [idx prop]
          (let [property-id  (or (:property/id prop)
                                 (get-in prop [:property :property/id])
                                 (str "search-result-" idx))
                address-text (let [addr (or (get-in prop [:address :full-address])
                                            (:full-address prop)
                                            (get-in prop [:property :address])
                                            (get-in prop [:property/primary-address :address/full-address])
                                            (:address prop))]
                               (if (string? addr)
                                 addr
                                 (or (:full-address addr)
                                     (:address/full-address addr)
                                     "Address not available")))]
            ^{:key (str "merge-prop-" idx "-" property-id)}
            [:div.flex.items-center.justify-between.p-3.bg-gray-50.rounded-lg.border
             [:div.flex.flex-col
              [:span.font-medium.text-sm (or property-id (tr [:property-view/property-id-unknown]))]
              [:span.text-xs.text-gray-600 address-text]]
             (when-not (zero? idx)
               [ui/button
                {:kind     :ghost
                 :size     :small
                 :on-click #(rf/dispatch [::property-subs/remove-selected-merge-property (dec idx)])}
                (tr [:remove])])]))
        all-properties)]]))

(defn action-buttons [tr parent-property selected-props]
  [:div.flex.justify-end.space-x-2
   [ui/button
    {:kind     :secondary
     :on-click #(rf/dispatch [::property-subs/show-merge-modal false])}
    (tr [:cancel])]

   [ui/button
    {:kind     :primary
     :disabled (empty? selected-props)
     :on-click #(rf/dispatch [::property-subs/complete-merge-selections parent-property])}
    (tr [:property-view/merge-properties])]])

(defn merge-modal [tr parent-property]
  (let [merge-form-data (<sub [::property-subs/merge-form-data])
        selected-props  (:properties merge-form-data)
        map-center      (<sub [::property-subs/merge-modal-map-center parent-property])
        markers         (<sub [::property-subs/merge-modal-markers parent-property])
        parent-shape    (<sub [::property-subs/merge-modal-parent-shape parent-property])
        merged-shapes   (<sub [::property-subs/merge-modal-merged-shapes])
        layers          (<sub [::municipality/municipal-layers (-> parent-property :property/group :group/id) false])]
    [ui-modal/composed-input-modal
     {:open       true
      :size       :lg
      :class-name "merge-properties-modal"
      :on-close   #(rf/dispatch [::property-subs/show-merge-modal false])}

     (cc/modal-header
       {:close-modal #(rf/dispatch [::property-subs/show-merge-modal false])
        :title       (tr [:property-view/merge-properties])})

     (cc/modal-body
       [:div.space-y-4
        [:p.text-sm.text-gray-600.mb-4 (tr [:property-view/merge-properties-description])]

        [:div.grid.grid-cols-1.lg:grid-cols-2.gap-4
         [:div
          [property-search-section tr parent-property]
          [selected-properties-list tr parent-property selected-props]]

         (when (and map-center layers)
           [:div.space-y-4
            [:h5.text-sm.font-medium.mb-3 (tr [:property-view/property-locations])]
            [:div.w-full.border.border-gray-300.rounded-lg
             {:style {:height "500px" :max-height "500px" :overflow "hidden" :position "relative"}}
             [workspace-map/workspace-map
              {:center               map-center
               :layers               layers
               :extended?            false
               :primaryMapMarkers    markers
               :secondaryMapMarkers  []
               :propertyGeometries   {:primaryPropertyGeometry      (when parent-shape
                                                                      (property-model/geojson-feature parent-shape))
                                      :additionalPropertyGeometries merged-shapes
                                      :roadSegmentGeometries        nil}
               :applicationTools     false
               :showApplicationTools false
               :enableDrawing        false
               :disableDrawing       true
               :interactionState     "DEFAULT"}]]])]])

     (cc/modal-footer
       [action-buttons tr parent-property selected-props])]))
